import { FC, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@hsp/react-component-library';

import { NotificationCenterIcon } from '@c/notifications/components/icon';

import { ProfileMenu } from 'components/layouts/shared/index';
import { ActionsProvider } from 'context/actions';
import { useSidebarStore } from 'store/sidebar';
import { buildUrl } from 'utilities/strings';

import './header.component.scss';

const Header: FC = () => {
  const isOpen = useSidebarStore((state) => state.open);
  const setOpen = useSidebarStore((state) => state.setOpen);

  const toggleSideBar = useCallback(() => setOpen(!isOpen), [isOpen, setOpen]);
  const home = useMemo(() => buildUrl('Root.path'), []);

  return (
    <>
      <header id="page-topbar">
        <div className="navbar-header">
          <div
            className="menu-bars"
            onClick={toggleSideBar}>
            <FontAwesomeIcon
              icon={['fas', 'bars']}
              size="lg"
            />
          </div>
          <div className="navbar-title">
            <Link
              className="logo"
              to={home}>
              <div className="navbar-brand-box">
                <img
                  alt=""
                  height="60"
                  src="/images/hsp-direct-logo.png"
                />
              </div>
            </Link>
            <div className="align-items-center d-flex h-100">
              <ActionsProvider>
                <NotificationCenterIcon />
              </ActionsProvider>
              <ProfileMenu />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
